import { useTranslate } from "ra-core";

import {
  ID_TYPE_LABELS,
  MARITAL_PROPERTY_REGIME_LABELS,
  MARITAL_STATUS_LABELS,
} from "../../providers/commons/contactExpediente";
import {
  ExpedienteSelectInput,
  ExpedienteTextInput,
  type ExpedienteFieldGroupProps,
} from "./ExpedienteField";

const SECTION_TITLE_CLASS = "text-lg font-semibold";
const GRID_CLASS = "grid grid-cols-1 gap-4 sm:grid-cols-2";

/**
 * Persona fisica fields of the Expediente: identity, civil status (the property regime shows only
 * when casado, like the clients form), occupation, full address and official ID. Controlled and
 * stateless; the parent owns the draft and validation.
 */
export const ExpedientePersonaFisicaFields = (
  props: ExpedienteFieldGroupProps,
) => {
  const translate = useTranslate();
  const isCasado = props.values.marital_status === "casado";
  return (
    <div className="flex flex-col gap-6">
      <section className="flex flex-col gap-4">
        <h3 className={SECTION_TITLE_CLASS}>
          {translate("crm.contact_expediente.section_fisica")}
        </h3>
        <div className={GRID_CLASS}>
          <ExpedienteTextInput {...props} field="rfc" maxLength={13} />
          <ExpedienteTextInput {...props} field="curp" maxLength={18} />
          <ExpedienteTextInput {...props} field="birth_date" type="date" />
          <ExpedienteTextInput {...props} field="birth_place" />
          <ExpedienteTextInput {...props} field="nationality" />
          <ExpedienteTextInput {...props} field="occupation" />
          <ExpedienteSelectInput
            {...props}
            field="marital_status"
            options={MARITAL_STATUS_LABELS}
          />
          {isCasado ? (
            <ExpedienteSelectInput
              {...props}
              field="marital_property_regime"
              options={MARITAL_PROPERTY_REGIME_LABELS}
            />
          ) : null}
        </div>
      </section>
      <section className="flex flex-col gap-4">
        <h3 className={SECTION_TITLE_CLASS}>
          {translate("crm.contact_expediente.section_address")}
        </h3>
        <div className={GRID_CLASS}>
          <ExpedienteTextInput {...props} field="address_street" />
          <ExpedienteTextInput {...props} field="address_number" />
          <ExpedienteTextInput {...props} field="address_neighborhood" />
          <ExpedienteTextInput {...props} field="address_zip" maxLength={5} />
          <ExpedienteTextInput {...props} field="address_municipality" />
          <ExpedienteTextInput {...props} field="address_state" />
        </div>
      </section>
      <section className="flex flex-col gap-4">
        <h3 className={SECTION_TITLE_CLASS}>
          {translate("crm.contact_expediente.section_id")}
        </h3>
        <div className={GRID_CLASS}>
          <ExpedienteSelectInput
            {...props}
            field="id_type"
            options={ID_TYPE_LABELS}
          />
          <ExpedienteTextInput {...props} field="id_expires_on" type="date" />
        </div>
      </section>
    </div>
  );
};
